import { I18n } from '@calendly/i18n'
import { BodyText, TitleText } from '@calendly/ui/components/typography'
import { colorTextSecondary } from '@calendly/ui/theme'
import { useDispatch, useSelector } from 'react-redux'

import { AddButton } from 'features/event_type_editor/control_panel/components'
import {
  assignedUserGroupsCountSelector,
  eventTypeSelector,
  isAssignPopupSubmittingSelector,
  OPEN_ASSIGN_POPUP_SCOPES,
  openAssignPopup
} from 'features/managed_event_types'

import { AddButtonWrapper, Container } from '../styles'
import { OrganizationGroups } from './organization_groups'

export const GroupSection = () => {
  const dispatch = useDispatch()
  const { owning_user_group: owningUserGroup } = useSelector(eventTypeSelector)
  const userGroupsCount = useSelector(assignedUserGroupsCountSelector)

  const disableGroupAssign = !!(owningUserGroup && userGroupsCount)

  const openAssignGroupsPopup = () => dispatch(
    openAssignPopup({
      scope: OPEN_ASSIGN_POPUP_SCOPES.groups,
      userGroupId: owningUserGroup?.id
    })
  )

  const isSubmitting = useSelector(isAssignPopupSubmittingSelector)
  const headingTextColor = userGroupsCount === 0 ? colorTextSecondary : null

  const addButtonSharedProps = {
    size: 'small',
    onClick: openAssignGroupsPopup,
    loading: isSubmitting
  }

  return (
    <>
      <Container bigGaps>
        <Container smallGaps>
          <TitleText size="small" level={3} color={headingTextColor}>
            {I18n.t('publisher.managed_event_types.event_type.section.group.title')}
          </TitleText>
          <BodyText size="medium" color="muted">
            {I18n.t('publisher.managed_event_types.event_type.section.group.subheader')}
          </BodyText>
        </Container>
        {userGroupsCount === 0 && (
          <AddButton {...addButtonSharedProps}>
            {I18n.t('publisher.managed_event_types.event_type.section.group.add_groups')}
          </AddButton>
        )}
      </Container>
      {userGroupsCount > 0 && (
        <div>
          <OrganizationGroups />
          <AddButtonWrapper>
            <AddButton {...addButtonSharedProps} disabled={disableGroupAssign}>
              {I18n.t('publisher.managed_event_types.event_type.section.group.add_groups')}
            </AddButton>
          </AddButtonWrapper>
        </div>
      )}
    </>
  )
}
